var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "max-width": "900",
        persistent: "",
        scrollable: ""
      },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event)
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Import Completion Reports")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _c("p", { staticClass: "text-body-2 mb-2" }, [
                _vm._v(" Upload a "),
                _c("strong", [_vm._v(".json")]),
                _vm._v(" or "),
                _c("strong", [_vm._v(".xlsx")]),
                _vm._v(
                  " file. All records must be valid before importing (all-or-nothing). Need the format? Download a template from the Reports page. "
                )
              ]),
              _c("v-file-input", {
                attrs: {
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  accept: ".json,.xlsx",
                  label: "Import file (.json / .xlsx)",
                  "prepend-inner-icon": "mdi-file-upload",
                  "prepend-icon": "",
                  loading: _vm.previewing
                },
                on: { change: _vm.onFileChange },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              }),
              _vm.parseError
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-4 mb-0",
                      attrs: { type: "error", dense: "", text: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.parseError) + " ")]
                  )
                : _vm._e(),
              _vm.preview
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center mt-4 mb-2",
                        staticStyle: { gap: "8px" }
                      },
                      [
                        _c("v-chip", { attrs: { small: "", label: "" } }, [
                          _vm._v(_vm._s(_vm.preview.count) + " record(s)")
                        ]),
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              small: "",
                              label: "",
                              color: _vm.validCount ? "green" : "grey",
                              dark: ""
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.validCount) + " valid ")]
                        ),
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              small: "",
                              label: "",
                              color: _vm.invalidCount ? "red" : "grey",
                              dark: ""
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.invalidCount) + " invalid ")]
                        )
                      ],
                      1
                    ),
                    _c("v-simple-table", {
                      attrs: { dense: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("#")]),
                                    _c("th", [_vm._v("Project")]),
                                    _c("th", [_vm._v("Date")]),
                                    _c("th", [_vm._v("Customer")]),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v("Scope")
                                    ]),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v("Work")
                                    ]),
                                    _c("th", { staticClass: "text-center" }, [
                                      _vm._v("Images")
                                    ]),
                                    _c("th", [_vm._v("Status")])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.preview.rows, function(row, i) {
                                    return _c(
                                      "tr",
                                      {
                                        key: i,
                                        class: _vm.rowErrors(i).length
                                          ? "red lighten-5"
                                          : ""
                                      },
                                      [
                                        _c("td", [_vm._v(_vm._s(i + 1))]),
                                        _c("td", [
                                          _vm._v(_vm._s(row.project_name))
                                        ]),
                                        _c("td", [_vm._v(_vm._s(row.date))]),
                                        _c("td", [
                                          _vm._v(_vm._s(row.customer_id))
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(row.scope_count))]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(row.work_count))]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [_vm._v(_vm._s(row.image_count))]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            !_vm.rowErrors(i).length
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "green",
                                                      dark: ""
                                                    }
                                                  },
                                                  [_vm._v("OK")]
                                                )
                                              : _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function({
                                                            on,
                                                            attrs
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-chip",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                        color:
                                                                          "red",
                                                                        dark: ""
                                                                      }
                                                                    },
                                                                    "v-chip",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.rowErrors(
                                                                          i
                                                                        ).length
                                                                      ) +
                                                                      " error(s) "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass: "my-1 pl-4"
                                                      },
                                                      _vm._l(
                                                        _vm.rowErrors(i),
                                                        function(msg, m) {
                                                          return _c(
                                                            "li",
                                                            { key: m },
                                                            [
                                                              _vm._v(
                                                                _vm._s(msg)
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        168286042
                      )
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v("Cancel")
              ]),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.canImport,
                    loading: _vm.importing
                  },
                  on: { click: _vm.doImport }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-database-import")
                  ]),
                  _vm._v(
                    " Import " +
                      _vm._s(_vm.preview ? _vm.preview.count : "") +
                      " report(s) "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }